import BaseService from './_base.service';

const URL = "/appsuscriptor/v2/rental";
// Validación de cupones desde el backoffice del hotel. Vive bajo
// /appsuscriptor/* porque cada repo solo consume su prefijo. El backend
// (SuscriptorCouponController) reusa CouponManager.rentTest existente y
// devuelve un DTO mínimo {id, name, code, percentage_discount,
// price_discount, priceDayRent}. El uso del cupón se contabiliza al START
// del alquiler, no aquí.
const URL_COUPON = "/appsuscriptor/v2/coupon";

export const rentService = {
    search,
    combo,
    page,
    pageFilter,
    one,
    create,
    edit,
    remove,
    removeLogic,
    cancel,
    end,
    freefiance,
    payfiance,
    closecar,
    openCar,
    commentStart,
    commentEnd,
    preview,
    testRentCoupon
};

function search(offset,callback) {
    return BaseService.get(URL+"/all/", callback,false,false)
}

function combo(callback) {
    return BaseService.get(URL+"/combo/", callback, false,false)
}

function page(page,size,callback) {
    return BaseService.get(URL+"/page/"+page+"/"+size, callback, false,false)
}

function cancel(id,callback) {
    return BaseService.get(URL+"/cancel/"+id, callback, false,false)
}

function openCar(id,callback) {
    return BaseService.get(URL+"/opencar/"+id, callback, false,false)
}

function closecar(id,callback) {
    return BaseService.get(URL+"/closecar/"+id, callback, false,false)
}

function end(id,callback) {
    return BaseService.get(URL+"/end/"+id, callback, false,false)
}

function freefiance(id,callback) {
    return BaseService.get(URL+"/end/free/"+id, callback, false,false)
}

function payfiance(id,body, callback) {
    return BaseService.post(URL+"/end/pay/"+id, body, callback, false,false)
}

function commentStart(id,body,callback) {
    return BaseService.post(URL+"/comment/start/"+id, JSON.stringify(body), callback, false,false)
}

function commentEnd(id,body,callback) {
    return BaseService.post(URL+"/comment/end/"+id, JSON.stringify(body), callback, false,false)
}

function pageFilter(page,size,filter,callback) {
    return BaseService.post(URL+"/page/"+page+"/"+size, filter, callback, false,false)
}

function one(id,callback) {
    return BaseService.get(URL + "/one/"+id, callback);
}


function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post(URL, body, callback, true)
}

// Previsualización del precio sin persistir el alquiler. Misma body shape
// que create() pero pega contra /preview. Sin loading panel (load=false)
// para que el debounce de NewRent no parpadee la UI.
function preview(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post(URL + "/preview", body, callback, false, false)
}

function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put(URL+"/"+id, body, callback, true)
}

function remove(id,callback) {
    return BaseService.delete(URL+"/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete(URL+"/"+id+"/logic", callback);
}

// Valida un código de cupón para crear un alquiler RENT. Body shape
// alineado con preview/create (user.email, suscription.id, modality, start,
// end) + coupon: { code }. Sin loading panel (mismo trato que preview) para
// no parpadear la UI cuando el usuario pulse Validar.
function testRentCoupon(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post(URL_COUPON + "/test", body, callback, false, false)
}

